/**
 * Our app uses role-based access however we are using an all-or-no one approach. So for now, we are
 * implementing an on/off system, so we need to convert that into an array of all roles (on) and no roles (off).
 */
 export const toRoles = (isOn: boolean, userRoles: string[]): string[] => isOn ? userRoles : [];

 /**
 * A list of characters or sequences that are not allowed in user searches.
 */
export const SEARCH_BLACKLIST = [
  '%',
];